export const isExtension =
	typeof chrome !== "undefined" && chrome.runtime && chrome.runtime.id;
